<script>
    import { createEventDispatcher } from 'svelte';
    export let placeholder;
    export let name;
    export let value = '';
    export let type;

    const dispatch = createEventDispatcher ();
    const handleChange = (event) => {
        let value = event.target.value

        if (type === 'textarea' && field) {
            field.style.height = '1px';
            field.style.height = field.scrollHeight + 'px';
        }

        else if (type === 'boolean') {
            value = event.target.checked;
        }

        dispatch ('fieldchange', {
            name: name,
            value: value
        })
    }

    let field = null
    let field_props = {
        name: name,
        value: value,
        placeholder: placeholder,
        autocomplete: 'off'
    }
</script>

<div class="simple-form-field">
    {#if type === 'textarea'}
        <textarea bind:this={field} on:input={handleChange} {...field_props}></textarea>
    {:else if type === 'boolean'}
        <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" checked={value} 
                id="customSwitch1" on:change={handleChange} />
            <label class="custom-control-label" for="customSwitch1"></label> <span class="switch-label">{placeholder}</span>
        </div>
    {:else}
        <input type={type} on:input={handleChange} {...field_props} />
    {/if}
</div>

<style>
    :global(.simple-form-field) :global(input) {
        background: #f4fafd;
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #bacad1;
        -webkit-appearance: none;
        outline: none;
        padding: 6px 15px;
    }

    :global(.simple-form-field) :global(textarea) {
        background: #f4fafd;
        border-radius: 0;
        border: none;
        padding: 6px 15px;
        border-bottom: 1px solid #bacad1;
        -webkit-appearance: none;
        outline: none;
        overflow: hidden;
        resize: vertical;
    }
    .switch-label {
        font-size: 14px;
        font-weight: 600;
    }
</style>